import type { CSSProperties, ReactNode } from "react";
import { tokens } from "@core/theme/tokens";

/**
 * Caja de aviso con marca redonda a la izquierda (revisión en vivo 2026-09-22,
 * punto #12B). Estaba DUPLICADA con dos firmas distintas:
 * `GrandPrizeConfigScreen.tsx:109` (con `mark`, `padding: 15px 16px`,
 * `borderRadius: 14`, `marginBottom: 16`) y `RuleEditorModal.tsx:39` (sin
 * `mark`, siempre "!", `padding: 14px 16px`, `borderRadius: 13`,
 * `marginTop: 6`).
 *
 * NOTA: el plan describe estas dos firmas al revés (dice que la de Gran premio
 * es la que no toma `mark`). En el código es como está escrito arriba.
 *
 * Unificación: `mark` con "!" por defecto cubre los dos usos, y la geometría
 * converge en la del Gran premio (los 1px de diferencia de `padding`/`radius`
 * entre las dos copias eran deriva, no una decisión). El margen NO se hornea:
 * cada llamador pasa el suyo por `style`, que es lo que deja al punto #12A
 * (el gap que falta en Gran premio) corregirse sin tocar este primitivo.
 */
export function InfoNotice({
  children,
  mark = "!",
  style,
}: {
  children: ReactNode;
  mark?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      style={{
        display: "flex",
        gap: 13,
        alignItems: "flex-start",
        padding: "15px 16px",
        borderRadius: 14,
        border: `1px solid ${tokens.surface.line2}`,
        background: tokens.surface.surface,
        ...style,
      }}
    >
      <div
        style={{
          width: 26,
          height: 26,
          borderRadius: "50%",
          flex: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid ${tokens.surface.line2}`,
          color: tokens.text.tertiary,
          font: `600 13px ${tokens.font.ui}`,
        }}
      >
        {mark}
      </div>
      <div
        style={{
          font: `400 12px/1.6 ${tokens.font.ui}`,
          color: tokens.text.tertiary,
        }}
      >
        {children}
      </div>
    </div>
  );
}
